"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.P = void 0;
var styled_components_1 = __importStar(require("styled-components"));
var react_1 = __importDefault(require("react"));
var variables_1 = require("../../../config/variables");
var getLineHeight = function (size) {
    switch (size) {
        case 'small':
            return '18px';
        case 'tiny':
            return 'normal';
        default:
            return '22px';
    }
};
var P_SIZES = {
    normal: variables_1.FONT_SIZE.NORMAL,
    small: variables_1.FONT_SIZE.SMALL,
    tiny: variables_1.FONT_SIZE.TINY,
};
var Paragraph = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    font-size: ", ";\n    line-height: ", ";\n    color: ", ";\n    padding: 0;\n    font-weight: ", ";\n    ", "\n"], ["\n    font-size: ", ";\n    line-height: ", ";\n    color: ",
    ";\n    padding: 0;\n    font-weight: ", ";\n    ",
    "\n"])), function (props) { return P_SIZES[props.size || 'normal']; }, function (props) { return getLineHeight(props.size); }, function (props) {
    return props.size === 'tiny' ? props.theme.TYPE_LIGHT_GREY : props.theme.TYPE_DARK_GREY;
}, function (props) { return (props.weight === 'normal' ? 'normal' : 600); }, function (props) {
    return props.textAlign && styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n            text-align: ", ";\n        "], ["\n            text-align: ", ";\n        "])), props.textAlign);
});
var P = function (_a) {
    var children = _a.children, className = _a.className, _b = _a.size, size = _b === void 0 ? 'normal' : _b, _c = _a.weight, weight = _c === void 0 ? 'normal' : _c, textAlign = _a.textAlign, rest = __rest(_a, ["children", "className", "size", "weight", "textAlign"]);
    return (react_1.default.createElement(Paragraph, __assign({ className: className, size: size, textAlign: textAlign, weight: weight }, rest), children));
};
exports.P = P;
var templateObject_1, templateObject_2;
